import { render, staticRenderFns } from "./CakeshopList.vue?vue&type=template&id=4296729e&"
import script from "./CakeshopList.vue?vue&type=script&lang=js&"
export * from "./CakeshopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports